/*
  APL matched paddle cover
  The "Custom Paddle Cover, Matched to Your Paddle" upsell: shows the paddle's own design on the cover while the
  shopper builds / browses, and when it is ordered attaches the cover print file to the cart line.
  Print file = the shop's Cover Template (5722 x 3825 px, 300 DPI): front on the left, back on the right.
  Design sources: the builders' 2mm print renderer (customer's real artwork) or, on designer / TOUR pages, the
  paddle face taken from the studio product photo.
  API: APLCover.attach(box, { getDesign: fn -> Promise<{front, back, source}>, title }) and APLCover.addToCart(box, qty, extra)
*/
(function () {
  if (window.APLCover) return;

  /* Cover Template geometry (px at 300 DPI) */
  var CW = 5722, CH = 3825, DPI = 300, SW = 2818, SH = 3825, FRONT_X = 26, BACK_X = 2886;
  var COVER_D = 'M2199 0 L2241 9 L2308 28 L2350 43 L2406 67 L2462 96 L2503 121 L2551 155 L2589 186 L2638 233 L2663 261 L2699 307 L2727 350 L2760 413 L2770 437 L2786 483 L2798 529 L2805 568 L2810 616 L2810 841 L2813 851 L2813 884 L2810 894 L2810 1412 L2813 1422 L2815 1728 L2818 1736 L2818 2077 L2815 2086 L2815 2186 L2813 2252 L2810 2261 L2810 2569 L2804 2634 L2794 2689 L2779 2747 L2765 2789 L2739 2851 L2715 2898 L2675 2963 L2630 3023 L2587 3072 L2521 3137 L2467 3179 L2390 3232 L1729 3710 L1719 3730 L1690 3825 L1126 3825 L1099 3740 L1094 3727 L1087 3716 L392 3214 L237 3085 L206 3053 L167 3006 L135 2962 L100 2906 L62 2830 L42 2779 L29 2738 L18 2695 L8 2643 L0 2559 L0 625 L4 578 L13 527 L23 488 L43 431 L70 374 L91 338 L119 297 L145 264 L167 239 L216 191 L257 157 L317 115 L354 93 L398 70 L453 46 L512 25 L566 10 L612 0 Z';
  /* Paddle 2mm print template (the design files every builder makes) */
  var TW = 2176, TH = 3375;
  var PADDLE_D = 'M609 0 L494 21 L448 33 L409 46 L352 70 L306 94 L270 116 L227 147 L193 176 L160 210 L135 240 L107 279 L80 322 L62 357 L44 400 L28 449 L11 540 L0 645 L0 2175 L4 2227 L11 2278 L22 2328 L36 2370 L54 2413 L74 2449 L96 2484 L126 2523 L158 2561 L197 2599 L241 2636 L370 2728 L691 2971 L773 3043 L821 3093 L840 3122 L884 3226 L896 3268 L917 3375 L1246 3375 L1249 3344 L1253 3321 L1279 3234 L1312 3175 L1342 3111 L1352 3095 L1369 3077 L1420 3027 L1485 2971 L1809 2726 L1948 2626 L2008 2571 L2049 2524 L2077 2488 L2099 2455 L2121 2414 L2135 2381 L2150 2340 L2160 2304 L2167 2265 L2172 2224 L2176 2171 L2176 652 L2167 556 L2155 484 L2148 450 L2132 401 L2114 358 L2092 317 L2067 276 L2036 233 L2008 201 L1980 174 L1941 141 L1907 117 L1859 88 L1822 69 L1769 47 L1731 34 L1685 22 L1566 0 Z';
  var coverPath = null, paddlePath = null;
  function cpath() { return coverPath || (coverPath = new Path2D(COVER_D)); }
  function ppath() { return paddlePath || (paddlePath = new Path2D(PADDLE_D)); }

  function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function loadImg(src) {
    return new Promise(function (resolve, reject) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { resolve(i); };
      i.onerror = function () { reject(new Error('load ' + src)); };
      i.src = src;
    });
  }
  /* any Shopify file URL -> same-origin path (canvas stays readable) at the given width */
  function sameOrigin(src, width) {
    try {
      var u = new URL(src, location.href), m = u.pathname.match(/\/files\/([^\/]+)$/);
      if (!m) return src;
      var name = m[1].replace(/_(\d+x\d*|x\d+)(@\dx)?(?=\.[a-z0-9]+$)/i, ''), v = u.searchParams.get('v');
      return '/cdn/shop/files/' + name + '?width=' + width + (v ? '&v=' + v : '');
    } catch (e) { return src; }
  }

  /* Average colour along the inside edge of the paddle face: fills anything the design can't reach */
  function edgeColor(src) {
    try {
      var c = canvas(64, 99), g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(src, 0, 0, 64, 99);
      var d = g.getImageData(0, 0, 64, 99).data, r = 0, gg = 0, b = 0, n = 0;
      [[8, 30], [55, 30], [8, 60], [55, 60], [32, 6], [20, 12], [44, 12]].forEach(function (p) {
        var i = (p[1] * 64 + p[0]) * 4;
        r += d[i]; gg += d[i + 1]; b += d[i + 2]; n++;
      });
      return 'rgb(' + Math.round(r / n) + ',' + Math.round(gg / n) + ',' + Math.round(b / n) + ')';
    } catch (e) { return '#FFFFFF'; }
  }

  /* One side of the cover (SW x SH at scale k): the paddle design scaled to the cover width, centred on the
     paddle's straight section, its outer corners continued from an enlarged copy so no white shows, then cut
     to the cover shape. */
  function coverSide(src, k) {
    var w = Math.round(SW * k), h = Math.round(SH * k), c = canvas(w, h), g = c.getContext('2d');
    if (!src) return c;
    var s = SW / TW, top = 1600 - 1450 * s;
    g.save();
    g.scale(k, k);
    g.fillStyle = edgeColor(src);
    g.fillRect(0, 0, SW, SH);
    /* enlarged copy behind, clipped to its own paddle shape */
    var E = 1.3, ex = (SW - TW * s * E) / 2, ey = top - TH * s * (E - 1) / 2;
    g.save();
    g.translate(ex, ey); g.scale(s * E, s * E);
    g.clip(ppath());
    g.drawImage(src, 0, 0, TW, TH);
    g.restore();
    /* the design itself */
    g.save();
    g.translate(0, top); g.scale(s, s);
    g.clip(ppath());
    g.drawImage(src, 0, 0, TW, TH);
    g.restore();
    g.globalCompositeOperation = 'destination-in';
    g.fill(cpath());
    g.restore();
    return c;
  }

  /* ---------- Print file ---------- */
  var IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function printCanvas(front, back) {
    var sc = IOS ? Math.min(1, Math.sqrt(16000000 / (CW * CH))) : 1;
    var c = canvas(Math.round(CW * sc), Math.round(CH * sc)), g = c.getContext('2d');
    c.dpi = Math.round(DPI * sc);
    g.fillStyle = '#FFFFFF';
    g.fillRect(0, 0, c.width, c.height);
    g.drawImage(coverSide(front, sc), Math.round(FRONT_X * sc), 0);
    g.drawImage(coverSide(back || front, sc), Math.round(BACK_X * sc), 0);
    return c;
  }
  function withDpi(blob, dpi) {
    return blob.arrayBuffer().then(function (buf) {
      var b = new Uint8Array(buf);
      if (b[2] === 0xFF && b[3] === 0xE0 && b[6] === 0x4A && b[7] === 0x46) { b[13] = 1; b[14] = dpi >> 8; b[15] = dpi & 255; b[16] = dpi >> 8; b[17] = dpi & 255; }
      return new Blob([b], { type: 'image/jpeg' });
    }).catch(function () { return blob; });
  }
  function toBlob(c, q) { return new Promise(function (r) { c.toBlob(r, 'image/jpeg', q); }); }
  var cmykP = null;
  function cmyk(url) {
    if (window.APLCmykJpeg) return Promise.resolve(true);
    if (!url) return Promise.resolve(false);
    if (!cmykP) cmykP = new Promise(function (resolve) {
      var s = document.createElement('script'); s.src = url; s.onload = function () { resolve(!!window.APLCmykJpeg); }; s.onerror = function () { resolve(false); };
      document.head.appendChild(s);
    });
    return cmykP;
  }
  /* CMYK JPG (falls back to RGB and says so), kept under 15 MB for the cart */
  function printFile(front, back, cmykUrl) {
    var c = printCanvas(front, back);
    return cmyk(cmykUrl).then(function () {
      var qs = [92, 85, 78, 70, 60];
      function step(i) {
        var p = window.APLCmykJpeg
          ? window.APLCmykJpeg.encode(c, c.dpi, qs[i]).then(function (b) { b.aplCmyk = true; return b; }).catch(function () { return toBlob(c, qs[i] / 100).then(function (b) { return withDpi(b, c.dpi); }); })
          : toBlob(c, qs[i] / 100).then(function (b) { return withDpi(b, c.dpi); });
        return p.then(function (b) { return (b.size > 15000000 && i < qs.length - 1) ? step(i + 1) : b; });
      }
      return step(0);
    });
  }

  /* ---------- Preview: the cover as the shopper will get it ---------- */
  function mockup(front, size) {
    var c = canvas(size, size), g = c.getContext('2d');
    g.fillStyle = '#FFFFFF';
    g.fillRect(0, 0, size, size);
    var k = (size * 0.86) / SH, w = SW * k, h = SH * k, x = (size - w) / 2, y = (size - h) / 2;
    g.save();
    g.translate(x, y);
    /* neoprene edge + soft shadow */
    g.save();
    g.scale(k, k);
    g.shadowColor = 'rgba(0,0,0,0.28)'; g.shadowBlur = 40; g.shadowOffsetY = 24;
    g.fillStyle = '#141414';
    g.fill(cpath());
    g.restore();
    g.drawImage(coverSide(front, k), 0, 0);
    /* rim */
    g.save();
    g.scale(k, k);
    g.lineJoin = 'round';
    g.strokeStyle = '#1B1B1B'; g.lineWidth = 46; g.stroke(cpath());
    g.strokeStyle = 'rgba(255,255,255,0.12)'; g.lineWidth = 6; g.stroke(cpath());
    /* zipper pull at the bottom right of the throat */
    g.fillStyle = '#9A9A9A';
    g.strokeStyle = '#3A3A3A'; g.lineWidth = 8;
    g.beginPath(); g.rect(1720, 3560, 70, 230); g.fill(); g.stroke();
    g.restore();
    /* gentle light from the top */
    var gr = g.createLinearGradient(0, 0, 0, h);
    gr.addColorStop(0, 'rgba(255,255,255,0.10)'); gr.addColorStop(0.5, 'rgba(255,255,255,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.10)');
    g.save(); g.scale(k, k); g.clip(cpath()); g.setTransform(1, 0, 0, 1, x, y); g.fillStyle = gr; g.fillRect(0, 0, w, h); g.restore();
    g.restore();
    return c;
  }

  /* ---------- Design from a studio product photo (designer / TOUR pages) ---------- */
  /* Finds the paddle face from the background around it; only accepts the standard front studio shot. */
  function faceFromPhoto(url) {
    return loadImg(sameOrigin(url, 2048)).then(function (im) {
      var N = 1000, ar = im.naturalHeight / im.naturalWidth;
      if (ar < 0.98 || ar > 1.02) return null;
      var c = canvas(N, N), g = c.getContext('2d', { willReadFrequently: true });
      g.drawImage(im, 0, 0, N, N);
      var d = g.getImageData(0, 0, N, N).data;
      function px(x, y) { var i = (y * N + x) * 4; return [d[i], d[i + 1], d[i + 2]]; }
      function diff(a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]); }
      function scanX(y, from, step) {
        var bg = px(from, y), x = from, hit = 0;
        for (; x > 0 && x < N - 1; x += step) { if (diff(px(x, y), bg) > 60) { if (++hit >= 2) return x - step; } else hit = 0; }
        return -1;
      }
      var ys = [300, 350, 400, 450], L = [], R = [];
      ys.forEach(function (y) { L.push(scanX(y, 4, 1)); R.push(scanX(y, N - 5, -1)); });
      L.sort(function (a, b) { return a - b; }); R.sort(function (a, b) { return a - b; });
      var left = L[1], right = R[2];
      var mid = Math.round((left + right) / 2), bgT = px(mid, 2), top = -1, hit = 0;
      for (var y = 2; y < 300; y++) { if (diff(px(mid, y), bgT) > 60) { if (++hit >= 2) { top = y - 1; break; } } else hit = 0; }
      var w = right - left;
      if (left < 0 || right < 0 || top < 0 || w < 340 || w > 520 || Math.abs(mid - 500) > 40 || top > 120) return null;
      /* skip the edge guard, then map the face onto the 2mm template */
      var e = w * 0.03, sx = (left + e) * im.naturalWidth / N, sy = (top + e) * im.naturalHeight / N, sw = (w - 2 * e) * im.naturalWidth / N;
      var sh = sw * TH / TW;
      var out = canvas(TW, TH), o = out.getContext('2d');
      o.fillStyle = '#FFFFFF'; o.fillRect(0, 0, TW, TH);
      o.save(); o.clip(ppath());
      o.drawImage(im, sx, sy, sw, sh, 0, 0, TW, TH);
      o.restore();
      out.aplFromPhoto = true;
      return out;
    }).catch(function () { return null; });
  }

  /* ---------- Upsell box wiring ---------- */
  function attach(box, opts) {
    if (!box || box.__aplCover) return;
    box.__aplCover = { opts: opts || {}, design: null, sig: '' };
    var st = box.__aplCover, img = box.querySelector('[data-cover-img]'), cb = box.querySelector('input[type="checkbox"]');
    var busy = false, again = false, io = null;
    function refresh() {
      if (!st.opts.getDesign) return;
      if (busy) { again = true; return; }
      busy = true;
      /* a builder that isn't ready yet can throw: treat that like "no design yet" so later updates still run */
      new Promise(function (r) { r(st.opts.getDesign(true)); }).then(function (dz) {
        if (!dz || !dz.front) return;
        st.design = dz;
        if (img) img.src = mockup(dz.front, 240).toDataURL('image/jpeg', 0.86);
        box.classList.add('has-design');
        if (io) { io.disconnect(); io = null; }
      }).catch(function () {}).then(function () {
        busy = false;
        if (again) { again = false; refresh(); }
      });
    }
    st.refresh = refresh;
    var t = 0;
    st.schedule = function () { clearTimeout(t); t = setTimeout(refresh, 700); };
    if (cb) cb.addEventListener('change', function () { box.classList.toggle('is-on', cb.checked); if (cb.checked) refresh(); });
    /* first preview: when the row scrolls into view (retried until a design is found) and once the page has settled */
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) refresh(); }); });
      io.observe(box);
    }
    setTimeout(refresh, 1200);
  }
  function isOn(box) { var cb = box && box.querySelector('input[type="checkbox"]'); return !!(cb && cb.checked); }
  function uncheck(box) { var cb = box && box.querySelector('input[type="checkbox"]'); if (cb) { cb.checked = false; box.classList.remove('is-on'); } }

  /* ---------- Checkout waits for files that are still being saved to the cart ---------- */
  var pending = [], waitEl = null;
  function hold(p) {
    pending.push(p);
    var drop = function () { pending = pending.filter(function (x) { return x !== p; }); };
    p.then(drop, drop);
    return p;
  }
  function whenIdle() {
    return pending.length ? Promise.all(pending.map(function (p) { return p.catch(function () {}); })).then(whenIdle) : Promise.resolve();
  }
  function showWait() {
    if (waitEl) return;
    waitEl = document.createElement('div');
    waitEl.setAttribute('role', 'status');
    waitEl.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,0.62);';
    waitEl.innerHTML = '<style>@keyframes aplHoldSpin{to{transform:rotate(360deg)}}</style>' +
      '<div style="max-width:320px;padding:22px 26px;border-radius:14px;border:1px solid rgba(255,255,255,0.15);background:#141414;color:#FFF;font:600 15px/1.4 sans-serif;text-align:center;">' +
      '<div style="width:28px;height:28px;margin:0 auto 12px;border:3px solid rgba(255,255,255,0.25);border-top-color:#D50A0A;border-radius:50%;animation:aplHoldSpin 0.8s linear infinite;"></div>' +
      'Saving your design for print…<br><span style="font-weight:500;font-size:13px;color:#BDBDBD;">Taking you to checkout in a moment.</span></div>';
    document.body.appendChild(waitEl);
  }
  document.addEventListener('click', function (e) {
    if (!pending.length) return;
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button__button, .shopify-payment-button button');
    if (!el) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showWait();
    whenIdle().then(function () {
      if (waitEl) { waitEl.remove(); waitEl = null; }
      if (el.tagName === 'A') { location.href = el.href; return; }
      var form = el.form || (el.closest && el.closest('form'));
      if (form && el.name === 'checkout') {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = el.value || 'Checkout';
        form.appendChild(h); form.submit(); return;
      }
      el.click();
    });
  }, true);
  window.addEventListener('beforeunload', function (e) { if (pending.length) { e.preventDefault(); e.returnValue = ''; } });

  /* Saves the finished print file onto the cover's cart line (found by its hidden _Cover ID). The properties already
     on the line are sent back so nothing is lost. */
  function attachToCover(token, props) {
    var tries = 0;
    function attempt() {
      tries++;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var it = (c.items || []).filter(function (x) { return x.properties && x.properties['_Cover ID'] === token; })[0];
        if (!it) return null;
        var fd = new FormData();
        fd.append('id', it.key);
        fd.append('quantity', it.quantity);
        Object.keys(it.properties).forEach(function (k) {
          var v = it.properties[k];
          if (v !== null && v !== undefined && !(k in props)) fd.append('properties[' + k + ']', v);
        });
        Object.keys(props).forEach(function (k) {
          var v = props[k];
          if (Array.isArray(v)) fd.append('properties[' + k + ']', v[0], v[1]); else fd.append('properties[' + k + ']', v);
        });
        return fetch('/cart/change.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r; });
      }).catch(function (err) {
        if (tries >= 3) throw err;
        return new Promise(function (r) { setTimeout(r, 1500 * tries); }).then(attempt);
      });
    }
    return attempt();
  }

  /* Adds the cover line straight away with its preview picture (shown in the cart), then saves the big print file onto
     it in the background. extra: properties to add (e.g. the paddle's _Paddle Design ID).
     opt.defer: don't start saving the print file - the result's finish() does it (builders run it after their own files).
     Otherwise saving starts at once and checkout waits for it. */
  function addToCart(box, qty, extra, opt) {
    if (!isOn(box)) return Promise.resolve(null);
    var st = box.__aplCover || {}, o = st.opts || {}, variant = box.getAttribute('data-cover-variant');
    var token = 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7), pfJob = null, dsrc = '';
    return new Promise(function (r) { r(o.getDesign ? o.getDesign(false) : null); }).catch(function () { return null; }).then(function (dz) {
      var fd = new FormData();
      fd.append('id', variant);
      fd.append('quantity', qty || 1);
      fd.append('properties[Matched to]', o.title || document.title);
      Object.keys(extra || {}).forEach(function (k) { fd.append('properties[' + k + ']', extra[k]); });
      fd.append('properties[_Cover ID]', token);
      if (!dz || !dz.front) {
        fd.append('properties[_Cover Print File]', 'Not made (no design found) - match the paddle above');
        return fd;
      }
      dsrc = dz.source;
      fd.append('properties[_Cover Print File]', 'Saving…');
      return toBlob(mockup(dz.front, 900), 0.88).then(function (pv) {
        if (pv) fd.append('properties[Final Preview Image]', pv, 'apl-cover-preview-' + Date.now() + '.jpg');
        /* the print file is made from this exact design now, while the cart request is on its way */
        pfJob = printFile(dz.front, dz.back, box.getAttribute('data-cmyk'));
        return fd;
      });
    }).then(function (fd) {
      return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      uncheck(box);
      var finish = function () {
        if (!pfJob) return Promise.resolve();
        return pfJob.then(function (pf) {
          var props = { '_Cover Print File': [pf, 'apl-cover-print-' + Date.now() + '.jpg'], '_Cover Print Colour': pf.aplCmyk ? 'CMYK (U.S. Web Coated SWOP v2)' : 'RGB (convert before printing)' };
          if (dsrc === 'photo') props['_Cover Design Source'] = 'Product photo (lower resolution) - use the original design file if you have it';
          return attachToCover(token, props);
        }).catch(function () {
          return attachToCover(token, { '_Cover Print File': 'MISSING - remake from the Final Preview Image' }).catch(function () {});
        });
      };
      if (opt && opt.defer) return { finish: finish };
      return { done: hold(finish()) };
    });
  }

  window.APLCover = { attach: attach, addToCart: addToCart, hold: hold, isOn: isOn, faceFromPhoto: faceFromPhoto, mockup: mockup, printCanvas: printCanvas, printFile: printFile, coverSide: coverSide };
})();
